export const MIN_AMOUNT = 10
export const MAX_AMOUNT = 2000
export const MIN_AMOUNT_LENGTH_TO_SCALE = 5
export const INPUT_CONTAINER_SCALE = 0.8
